<div class="small pr-2">
  <div
    class="log d-flex no-gutterts flex-wrap align-items-center"
    *ngFor="let log of transactionLogsFiltered"
    (click)="goto(log.code)"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
  >
    <div
      class="col-1 p-0 date d-flex flex-column justify-content-center align-items-center"
    >
      <mat-icon
        class="small"
        [matTooltip]="(log.createdOn | date: 'MM/dd/yy hh:mm') || ''"
        >schedule</mat-icon
      >
      <mat-icon
        *ngIf="log.objectJson"
        class="small blue"
        [matTooltip]="log.objectJson"
        >comment</mat-icon
      >
    </div>
    <div class="col-9 p-0 wrap log-item">
      <span [innerHTML]="log.name"></span>
    </div>

    <div
      class="col-2 p-0 d-flex justify-content-end small"
      [matTooltip]="log.createdByName ?? ''"
    >
      {{ log.createdByInitials }}
    </div>

    <mat-menu #menu="matMenu" class="log-menu card">
      <div class="card-header">
        <span class="date small">{{
          log.createdOn | date: "MM/dd/yy hh:mm"
        }}</span
        ><span class="small"> by {{ log.createdByName }}</span>
        <br />
        <span [innerHTML]="log.name" class="mb-2"></span>
      </div>
      <div class="card-body">
        <div
          class="small wrap log-item log-description"
          *ngIf="log.description"
          [innerHTML]="log.description"
        ></div>
      </div>
      <div
        class="card-footer"
        *ngIf="log.createdBy == currentUser?.id || log.objectJson"
      >
        <div
          (click)="$event.stopPropagation()"
          (mousedown)="$event.stopPropagation()"
        >
          <textarea
            [placeholder]="'Add comments here...'"
            class="form-control small"
            rows="3"
            [readOnly]="currentUser?.id != log.createdBy"
            [(ngModel)]="log.objectJson"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
          ></textarea>
          <div
            class="mt-2 d-flex gap-2 justify-content-center"
            *ngIf="currentUser?.id == log.createdBy"
          >
            <button
              mat-flat-button
              color="primary"
              (click)="
                save(log); menuTrigger.closeMenu(); $event.stopPropagation()
              "
            >
              Save
            </button>

            <button
              mat-stroked-button
              color="warn"
              (click)="menuTrigger.closeMenu(); $event.stopPropagation()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </mat-menu>
  </div>
</div>
